import { motion } from "framer-motion";
import { Mic } from "lucide-react";
import { TIDYCAL_URL } from "@/constants";

const TOPICS = [
  "Artificial Intelligence",
  "Future of Work",
  "Technology Adoption",
  "Innovation",
  "Digital Literacy",
  "Technology & Education",
  "Youth Technology",
  "Entrepreneurship",
  "Organizational Change",
];

export default function SpeakingTopics() {
  return (
    <section id="speaking" data-testid="speaking-topics-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
            Keynotes & Conferences
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6">
            Ideas that make audiences think — <span className="italic text-primary">and act.</span>
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed font-light text-foreground/80">
            Phillip is available for keynotes, conferences, leadership meetings,
            and organizational events focused on:
          </motion.p>
          <motion.a
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            href={TIDYCAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="speaking-book-button"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-primary text-primary-foreground px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-lg hover:shadow-primary/20 transition-transform duration-300"
          >
            <Mic className="w-5 h-5" />
            Book Phillip to Speak
          </motion.a>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: "easeOut" }}
          className="lg:col-span-5 lg:col-start-8 self-center"
        >
          <div className="flex flex-wrap gap-3" data-testid="speaking-topics">
            {TOPICS.map((t) => (
              <span key={t} className="rounded-full border border-[#D8D4CA] bg-background px-5 py-2.5 text-sm text-foreground/80">
                {t}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
